<div class="modal-backdrop fade" [class.show]="show"></div>
<div
  class="modal d-block fade"
  [class.show]="show"
  tabindex="-1"
  role="dialog"
  aria-labelledby="modalIdLabel"
>
  <div
    role="document"
    class="modal-dialog modal-dialog-centered"
    style="max-width: 70%"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title text-primary-dark">Orders Report</h5>
        <button
          type="button"
          class="close ml-0 d-print-none"
          (click)="close()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-header">
        <p-calendar
          yearRange="2000:2030"
          selectionMode="range"
          [monthNavigator]="true"
          [yearNavigator]="true"
          [(ngModel)]="dateRange"
          [readonlyInput]="true"
          [showButtonBar]="true"
          #calendar
        >
          <p-footer>
            <div>
              <button
                [disabled]="!dateRange"
                class="btn btn-primary btn-small calender-okay"
                (click)="onRangeChange($event); calendar.hideOverlay()"
              >
                Ok
              </button>
            </div>
          </p-footer>
        </p-calendar>
        <a class="modal-title ml-auto pr-4 export pt-1 d-print-none">
          <h6 class="text-dark" (click)="onPrint()">Print</h6>
        </a>
        <a
          class="modal-title export pt-1 d-print-none"
          *ngIf="data$ | async as data"
        >
          <h6 class="text-dark" (click)="onExport(data)">Export Excel</h6>
        </a>
      </div>
      <ng-template #loader>
        <div style="padding-top: 20%">
          <div class="text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      </ng-template>
      <div class="modal-body row" *ngIf="data$ | async as data; else loader">
        <div class="sections col">
          <div class="headers">
            <div class="tile">
              <div class="title">Orders Made</div>
              <div class="value">
                {{ data.summary.total_orders | shortNumber }}
              </div>
            </div>
            <div class="tile">
              <div class="title">Cancelled</div>
              <div class="value text-danger">
                {{ data.summary.cancelled | shortNumber }}
              </div>
            </div>
            <div class="tile">
              <div class="title">Deliveries</div>
              <div class="value">
                {{ data.summary.delivered | shortNumber }}
              </div>
            </div>
            <div class="tile">
              <div class="title">Avg Delivery time</div>
              <div class="value">
                {{
                  data.summary.avg_delivery_time | number: "1.0-2" | shortNumber
                }}
                hours
              </div>
            </div>
          </div>
          <div class="categories">
            <div class="text-primary-dark font-weight-bold">
              Orders by category
            </div>
            <div
              class="bar-graph"
              *ngIf="
                data.input_categories.length > 0 &&
                  data.input_categories as input_categories;
                else noData
              "
            >
              <div class="bar" *ngFor="let item of input_categories">
                <div class="progress-label">{{ item.name }}</div>
                <div class="progress">
                  <div
                    class="progress-bar bg-primary-light mr-4"
                    role="progressbar"
                    [style.width]="item.percentage + '%'"
                  ></div>
                  <span class="title">UGX {{ item.total | number }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="categories">
            <div class="text-primary-dark font-weight-bold">
              Top ordered Items
            </div>
            <div
              *ngIf="
                data.ordered_items.length > 0 &&
                  data.ordered_items as ordered_items;
                else noData
              "
            >
              <table class="table lower">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Times Ordered</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let item of ordered_items.slice(0, 5);
                      let i = index
                    "
                  >
                    <th scope="row">{{ i + 1 }}</th>
                    <td>{{ item.name }} - ({{ item.unit }})</td>
                    <td>
                      <span class="pr-2">{{ item.orders }}</span>
                      <span>{{ item.percentage / 100 | percent }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="summary col-4">
          <div class="tile">
            <div class="title text-dark">Total Sales</div>
            <div class="value">
              {{ data.summary.total_sales | shortNumber: "UGX" }}
            </div>
          </div>
          <div class="tile">
            <div class="title d-inline-flex">
              <div>Top Product</div>
              <span>
                <ezy-icons name="/assets/icons/star.svg" class="pl-2"></ezy-icons>
              </span>
            </div>
            <ng-container *ngIf="data.top_product as top_product; else noData">
              <div class="font-weight-bold text-primary-dark">
                {{ top_product.name }} - {{ top_product.unit }}
              </div>
              <div class="title p-0">
                <small>Orders {{ top_product.orders }} time(s)</small>
              </div>
            </ng-container>
          </div>
          <div class="tile customers">
            <div>
              <div class="value large text-purple">
                {{ data.summary.new_customers | shortNumber }}
              </div>
              <div class="title text-weight-bold text-dark">New Customers</div>
            </div>
            <div>
              <div class="value large">
                {{ data.summary.returning_customers | shortNumber }}
              </div>
              <div class="title text-weight-bold text-dark">
                Returning Customers
              </div>
            </div>
          </div>
          <div>
            <canvas
              baseChart
              [data]="orderTypes"
              [labels]="offLineDataLabels"
              chartType="doughnut"
              *ngIf="
                data.summary.order_types.length > 0 &&
                  data.summary.order_types as orderTypes;
                else noData
              "
              [colors]="doughnutChartColors"
              [options]="options"
            ></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #noData>
  <div class="text-primary-dark">No data for selected range</div>
</ng-template>
